import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60ac5705"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card__release_course"
}
const _hoisted_2 = {
  key: 1,
  class: "event__certificate"
}
const _hoisted_3 = { class: "event__image" }
const _hoisted_4 = { class: "class__type" }
const _hoisted_5 = { class: "event__content" }
const _hoisted_6 = { class: "event__name" }
const _hoisted_7 = { class: "class__information__bottom" }
const _hoisted_8 = { class: "class__info" }
const _hoisted_9 = { class: "class__info" }
const _hoisted_10 = { class: "class__info" }
const _hoisted_11 = { class: "class__info" }
const _hoisted_12 = { class: "class__info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NewContentEventFlag = _resolveComponent("NewContentEventFlag")!
  const _component_VideoPlayButton = _resolveComponent("VideoPlayButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: "event",
    onMousedown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.pressing && _ctx.pressing(...args))),
    onMousemove: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.moving && _ctx.moving(...args))),
    onTouchend: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.releasing && _ctx.releasing(...args))),
    onTouchmove: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.moving && _ctx.moving(...args))),
    onTouchstart: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.pressing && _ctx.pressing(...args))),
    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.releasing && _ctx.releasing(...args))),
    "data-card-event": ""
  }, [
    (_ctx.isNewCourse())
      ? (_openBlock(), _createElementBlock("span", _hoisted_1))
      : _createCommentVNode("", true),
    (_ctx.event.hasCertificate)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.event.type === 1 ? "Evento" : "Treinamento"), 1),
      (_ctx.event.hasNewContent)
        ? (_openBlock(), _createBlock(_component_NewContentEventFlag, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.event.introductoryContent)
        ? (_openBlock(), _createBlock(_component_VideoPlayButton, {
            key: 1,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openIntroductoryContent())),
            class: "video-play-button"
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.event.name), 1),
      _createElementVNode("address", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, "Local: " + _toDisplayString(_ctx.event.type === 1 ? _ctx.event.classes[0].location : _ctx.event.location), 1),
        (_ctx.event.type === 2)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("span", _hoisted_9, " Data: " + _toDisplayString(_ctx.formatMenusDates(_ctx.event.menus)), 1),
              _createElementVNode("span", _hoisted_10, " Horário: " + _toDisplayString(_ctx.formatMenusSchedule(_ctx.event.menus)), 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("span", _hoisted_11, " Data: " + _toDisplayString(_ctx.formattedDate(_ctx.event.classes[0].scheduleStartDateTime)), 1),
              _createElementVNode("span", _hoisted_12, " Horário: " + _toDisplayString(_ctx.formatOneTime(_ctx.event.classes[0].scheduleStartDateTime)) + " até " + _toDisplayString(_ctx.formatOneTime(_ctx.event.classes[0].scheduleEndDateTime)), 1)
            ], 64))
      ])
    ])
  ], 32))
}